






import React, { useEffect, useState } from 'react';
import ToolCardInt from '../ToolsInt/ToolCardInt';
import './FlagInt.css';
import { GET, getQuery, makeApiCal } from '../../util';
import Bar from '../../Resources/SlidesInt/flagBar2.png';
import Grey from '../../Resources/SlidesInt/greyCircle.png';
import OrangeLoader from '../../Resources/SlidesInt/Orangeloader .gif';
import OrangeTick from '../../Resources/SlidesInt/orangeTick.png';
import BlueTick from '../../Resources/SlidesInt/blueTick.png';
import BlueLoader from '../../Resources/SlidesInt/blueLoader.gif';
import GreenLoader from '../../Resources/SlidesInt/greenLoader.gif';
import GreenTick from "../../Resources/SlidesInt/GreenTIck.png";
import flagCircle from '../../Resources/SlidesInt/flagCircle.png';
import Lights from '../../Resources/SlidesInt/lights.png';

function FlagInt(props) {
	const [apiData, setApiData] = useState();
	const [err, catchError] = useState(false);
	const [percentageCompleted, setPercentangeCompleted] = useState(50);
	const [isWinning, setIsWinning] = useState(false);
	const [isComplete, setIsComplete] = useState();
	const [isCurrentlyActive, setIsCurrentlyActive] = useState();
	const [isPercentage, setIsPercentage] = useState();

	const getData = () => {
		const action = {
			method: GET,
			route: 'v1/campaign/detailPage',
			storeData: setApiData,
			catchError: catchError,
		};
		makeApiCal(action);
	};
	// console.log(apiData);

	useEffect(() => {
		getData();
		// console.log(props);
		// if (apiData!==undefined){
		// 	console.log(apiData);
		// }
	}, []);

	let percent = 100 - parseInt(percentageCompleted) + '%';
	console.log(percent);
	return (
		<div className="flagInt-container">
			 <img src= {Lights} className='internal-Lightflag'/>
			<div className="flagInt-main">
				<div className="flagInt-heading">{apiData?.flagPage?.heading}</div>
				<div className="flagInt-Subheading">{apiData?.flagPage?.text}</div>
				<div className="completeFlag-main">
					<div className="flagData-container">
						<div className="flagBar">
							<img src={Bar} />
						</div>

						<div className="flag-parent">
							{/* for orange data start  */}
							<div className="orange-buttons">
								<div className="image1">
									{apiData?.flagPage?.flagData?.[0].isCurrentlyActive === 1 ? (
										<img src={OrangeLoader} />
									) : apiData?.flagPage?.flagData?.[0].isComplete === 0 ? (
										<img src={Grey} />
									) : (
										<img src={GreenTick} />
									)}
								</div>
								<div className="progress-bar-flag">
									<div
										className="progress-fill-flag"
										style={{
											width:
												apiData?.flagPage?.flagData?.[0].isComplete === 1
													? '100%'
													: apiData?.flagPage?.flagData?.[0]
															.isCurrentlyActive === 1
													? apiData?.flagPage?.flagData?.[0].percentage
													: '0%',

											backgroundColor: '#FD7C45 ',
											// borderRadius: "20px",
											// boxShadow: "0px 6px 10px 0px pink",
												
										}}
									></div>
								</div>
							</div>
							{/* for orange data end */}
							<div className="orange-buttons">
								<div className="image1">
									{apiData?.flagPage?.flagData?.[1].isCurrentlyActive === 1 ? (
										<img src={BlueLoader} />
									) : apiData?.flagPage?.flagData?.[1].isComplete === 0 ? (
										<img src={Grey} />
									) : (
										<img src={GreenTick} />
									)}
								</div>
								<div className="progress-bar-flag2">
									<div
										className="progress-fill-flag"
										style={{
											width: apiData?.flagPage?.flagData?.[1].isComplete === 1
											// width:
											// 	isComplete === 1
											// 		? '85%'
											// 		: isCurrentlyActive === 0
											// 		? isPercentage + '%'
											// 		: '0%',
											? '100%'
											: apiData?.flagPage?.flagData?.[1]
													.isCurrentlyActive === 1
											? apiData?.flagPage?.flagData?.[1].percentage
											: '0%',
											backgroundColor: 'white',
										}}

									>
										{/* {
											apiData?.flagPage?.flagData?.[1].percentage == 100 ? <img className='flagCircle' src={flagCircle}/> : <></>
										} */}
										
									</div>
								</div>
							</div>

							{/* for blue data end  */}
							<div className="orange-buttons">
							<div className="image1">
									{apiData?.flagPage?.flagData?.[2].isCurrentlyActive === 1 ? (
										<img src={GreenLoader} />
									) : apiData?.flagPage?.flagData?.[2].isComplete === 0 ? (
										<img src={Grey} />
									) : (
										<img src={GreenTick} />
									)}
								</div>
							<div className="progress-bar-flag">
								<div
									className="progress-fill-flag"
									style={{
										width: apiData?.flagPage?.flagData?.[2].isComplete === 1
										? '100%'
											: apiData?.flagPage?.flagData?.[2]
													.isCurrentlyActive === 1
											? apiData?.flagPage?.flagData?.[2].percentage + "%"
											: '0%',
										backgroundColor:
											'#00938A',
									}}
								></div>
							</div>
							</div>
							{/* for green data end  */}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default FlagInt;
